import { createReducer, on } from '@ngrx/store';
import { ProjectChangeControlActions } from './project-change-control.actions';
import {
  initialProjectChangeControlState,
  ProjectChangeControlState,
} from './project-change-control.state';

export const projectChangeControlReducer = createReducer<ProjectChangeControlState>(
  initialProjectChangeControlState,

  on(ProjectChangeControlActions.openDialog, (state, { apuCategory, actionContext, projectId, requestorName }) => ({
    ...state,
    isDialogOpen: true,
    pendingApuCategory: apuCategory,
    pendingActionContext: actionContext,
    pendingRequest: {
      projectId,
      requestorName: requestorName ?? '',
      apuCategories: [apuCategory],
    },
    error: null,
  })),

  on(ProjectChangeControlActions.closeDialog, (state) => ({
    ...state,
    isDialogOpen: false,
    pendingRequest: null,
    pendingApuCategory: null,
    pendingActionContext: null,
    error: null,
  })),

  // ─── Load Requests ────────────────────────────────────────

  on(ProjectChangeControlActions.loadRequests, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(ProjectChangeControlActions.loadRequestsSuccess, (state, { requests }) => ({
    ...state,
    loading: false,
    changeRequests: requests,
  })),

  on(ProjectChangeControlActions.loadRequestsFail, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // ─── Submit Request ───────────────────────────────────────

  on(ProjectChangeControlActions.submitRequest, (state) => ({
    ...state,
    submitting: true,
    error: null,
  })),

  on(ProjectChangeControlActions.submitRequestSuccess, (state, { request }) => ({
    ...state,
    submitting: false,
    isDialogOpen: false,
    pendingRequest: null,
    pendingApuCategory: null,
    pendingActionContext: null,
    lastSubmittedRequest: request,
    changeRequests: [request, ...state.changeRequests],
  })),

  on(ProjectChangeControlActions.submitRequestFail, (state, { error }) => ({
    ...state,
    submitting: false,
    error,
  })),

  // ─── Changed Categories ────────────────────────────────────

  on(ProjectChangeControlActions.trackCategoryChange, (state, { category }) => {
    const exists = state.changedCategories.findIndex(
      c => c.apuCategoryId === category.apuCategoryId
    );
    const updated = [...state.changedCategories];
    if (exists >= 0) {
      updated[exists] = category;
    } else {
      updated.push(category);
    }
    return { ...state, changedCategories: updated };
  }),

  on(ProjectChangeControlActions.removeCategoryChange, (state, { apuCategoryId }) => ({
    ...state,
    changedCategories: state.changedCategories.filter(c => c.apuCategoryId !== apuCategoryId),
  })),

  on(ProjectChangeControlActions.clearChangedCategories, (state) => ({
    ...state,
    changedCategories: [],
  })),

  on(ProjectChangeControlActions.setFieldContext, (state, { context }) => ({
    ...state,
    activeFieldContext: context,
  })),

  // ─── Misc ─────────────────────────────────────────────────

  on(ProjectChangeControlActions.clearLastSubmitted, (state) => ({
    ...state,
    lastSubmittedRequest: null,
  })),

  on(ProjectChangeControlActions.clearState, () => ({
    ...initialProjectChangeControlState,
  })),
);
